import * as React from 'react';
/**
 *
 * Original name: delete
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1084
 *
 */
export const DeleteLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M19.5 7h-4v-.75A2.25 2.25 0 0 0 13.25 4h-2.997a2.25 2.25 0 0 0-2.25 2.255V7H4v1.5h1.591l1.245 9.541A2.256 2.256 0 0 0 9.067 20h5.366a2.256 2.256 0 0 0 2.231-1.959L17.908 8.5H19.5V7Zm-9.997-.75a.75.75 0 0 1 .75-.75h2.997a.75.75 0 0 1 .75.75V7H9.505l-.002-.75Zm5.674 11.595a.75.75 0 0 1-.744.655H9.067a.75.75 0 0 1-.744-.654L7.104 8.5h9.292l-1.219 9.345Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
